import { hydrateComponentTag } from './hydrate.constants.tsx';

/**
 * When this attribute is present on sk-hydrate, it means that the hydration process has been completed.
 * web-components should wait for this attribute to be present before they start modifying the DOM.
 */
export const hydrationCompletedAttribute = 'data-hydration-completed';

/**
 * Waits until the closest sk-hydrate element has completed hydration.
 * web-components should wait for this before they start modifying the DOM.
 */
export const waitUntilHydrated = (element: HTMLElement): Promise<void> => {
  const skHydrate = element.closest(hydrateComponentTag);
  if (
    !skHydrate ||
    skHydrate === element ||
    skHydrate.getAttribute(hydrationCompletedAttribute) === 'true'
  ) {
    return Promise.resolve();
  } else {
    return new Promise(resolve => {
      const observer = new MutationObserver(() => {
        if (skHydrate.getAttribute(hydrationCompletedAttribute) === 'true') {
          observer.disconnect();
          resolve();
        }
      });
      observer.observe(skHydrate, { attributes: true });
    });
  }
};
